import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { Field } from 'formik';
import React, { useState } from 'react';
import { makeStyles } from 'tss-react/mui';

import { getRealEstateSubTypes } from 'app-components/flux/house-stats/houseStatsUtils';
import NestedQMenu from 'components/NestedQMenu';

const useStyles = makeStyles()(() => ({
  field: {
    cursor: 'pointer',
  },
}));

const residenceMenu = getRealEstateSubTypes().map((item) => ({
  label: item.displayName,
  value: item.qcsSubType,
}));

const vehicleMenu = [
  {
    label: 'Primary Vehicle',
    value: {
      id: 'primaryVehicle',
      displayName: 'Primary Vehicle',
      qcsType: 'primaryVehicle',
      selectable: true,
      connectable: true,
      other: false,
    },
  },
  {
    label: 'Secondary Vehicle',
    value: {
      id: 'secondaryVehicle',
      displayName: 'Secondary Vehicle',
      qcsType: 'secondaryVehicle',
      selectable: true,
      connectable: true,
      other: false,
    },
  },
  {
    label: 'Investment Vehicle',
    value: {
      id: 'investmentVehicle',
      displayName: 'Investment Vehicle',
      qcsType: 'investmentVehicle',
      selectable: true,
      connectable: true,
      other: false,
    },
  },
  {
    label: 'Other',
    value: {
      id: 'other',
      displayName: 'Other',
      qcsType: 'other',
      selectable: true,
      connectable: true,
      other: false,
    },
  },
];

const TypeSelector = (props: {
  name: string;
  realestate: boolean;
  id: string;
}) => {
  const { name = 'residenceType', realestate, id } = props;
  const createItems = realestate ? residenceMenu : vehicleMenu;

  const { classes } = useStyles();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  // @ts-expect-error FIXME TS7006
  const handleChange = (form) => (val) => {
    form.setFieldValue(name, val);
    setAnchorEl(null);
  };

  return (
    <Field id={id} name={name}>
      {/*
       // @ts-expect-error FIXME TS7031 */}
      {({ field, form }) => (
        <>
          <TextField
            {...field}
            onChange={() => true}
            onClick={(e) => setAnchorEl(e.currentTarget)}
            onKeyDown={(e) => {
              if (e.key === ' ' || e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                e.preventDefault();
                setAnchorEl(e.currentTarget);
              }
            }}
            value={createItems.find((entry) => entry.value === field.value)?.label}
            label={realestate ? 'Residence Type' : 'Vehicle Type'}
            id={id || 'type-select'}
            fullWidth
            InputProps={{
              readOnly: true,
              endAdornment: (
                <InputAdornment position='end'>{anchorEl ? <ExpandLessIcon /> : <ExpandMoreIcon />}</InputAdornment>
              ),
            }}
            className={classes.field}
          ></TextField>
          <NestedQMenu
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            options={createItems}
            onChange={handleChange(form)}
            onClose={() => setAnchorEl(null)}
          />
        </>
      )}
    </Field>
  );
};

export default TypeSelector;
